module.exports = __webpack_public_path__ + "static/media/schizophrenia.7dac409f.svg";